/* ============================================================
   alnashir-fix.js  — يُحمَّل بـ defer من <head>
   ============================================================ */

(function () {
  'use strict';

  var arrowSyncers = [];
  var loops = [];

  var REDUCED = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;


  function gapOf(track) {
    var g = parseFloat(window.getComputedStyle(track).columnGap);
    return isNaN(g) ? 0 : g;
  }


  /* حلقة لا نهائية على سكرول أصلي: ثلاث كتل متطابقة، البداية من
     الوسطى، والقفزة غير مرئية لتطابق المحتوى عند x و x+كتلة. */
  function makeInfinite(viewport, track, unitNodes) {
    if (!unitNodes.length) return null;

    var gap = gapOf(track);

    while (track.firstChild) track.removeChild(track.firstChild);

    unitNodes.forEach(function (node) {
      node.removeAttribute('aria-hidden');
      node.removeAttribute('tabindex');
      track.appendChild(node);
    });

    var blockPitch = track.scrollWidth + gap;
    if (blockPitch < 40) return null;

    function addBlock() {
      var frag = document.createDocumentFragment();

      unitNodes.forEach(function (node) {
        var copy = node.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('tabindex', '-1');
        frag.appendChild(copy);
      });

      track.appendChild(frag);
    }

    addBlock();
    addBlock();

    var guard = 0;

    while (track.scrollWidth - viewport.clientWidth < blockPitch * 2 && guard < 6) {
      addBlock();
      guard++;
    }

    var rtl = window.getComputedStyle(viewport).direction === 'rtl';

    function getPos() { return rtl ? -viewport.scrollLeft : viewport.scrollLeft; }
    function setPos(v) { viewport.scrollLeft = rtl ? -v : v; }

    function normalize() {
      var pos = getPos();

      if (pos < blockPitch) { setPos(pos + blockPitch); return; }
      if (pos >= blockPitch * 2) { setPos(pos - blockPitch); }
    }

    setPos(blockPitch);

    viewport.addEventListener('scroll', normalize, { passive: true });

    return { getPos: getPos, setPos: setPos, normalize: normalize };
  }


  function enableMouseDrag(viewport, onInteract) {
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;

      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = viewport.scrollLeft;
      viewport.classList.add('is-grabbing');

      if (onInteract) onInteract();
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;

      var delta = e.clientX - startX;
      if (Math.abs(delta) > 5) moved = true;
      if (!moved) return;

      viewport.scrollLeft = startScroll - delta;
      if (onInteract) onInteract();
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-grabbing');
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    viewport.addEventListener('click', function (e) {
      if (!moved) return;
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }, true);
  }


  /* ============================================================
     كاروسيلات البراندات والتصنيفات
     ============================================================ */

  function buildMarquee(oldCarousel) {
    if (oldCarousel.getAttribute('data-anx-native-rail') === '1') return;
    oldCarousel.setAttribute('data-anx-native-rail', '1');
    oldCarousel.removeAttribute('aria-roledescription');

    var track = oldCarousel.querySelector('[id^="bcTrack-"]');
    if (!track) return;

    var pause = oldCarousel.querySelector('[id^="bcPause-"]');
    if (pause && pause.parentNode) pause.parentNode.removeChild(pause);

    var dots = oldCarousel.querySelector('[id^="bcDots-"]');
    if (dots && dots.parentNode) dots.parentNode.removeChild(dots);

    Array.prototype.forEach.call(track.querySelectorAll('[aria-hidden="true"]'), function (item) {
      if (item.parentNode === track) item.parentNode.removeChild(item);
    });

    var viewport = document.createElement('div');
    viewport.className = 'anx-marquee';

    track.parentNode.insertBefore(viewport, track);
    viewport.appendChild(track);

    track.style.transform = '';
    track.style.transition = '';
    enableMouseDrag(viewport, null);
  }


  /* ============================================================
     مسارات المنتجات
     ============================================================ */

  function standDownLegacy(scope) {
    var root = scope || document;

    Array.prototype.forEach.call(
      root.querySelectorAll('.alnashir-best-selling'),
      function (s) { s.dataset.nbssInitialized = 'true'; }
    );

    Array.prototype.forEach.call(
      root.querySelectorAll('[id^="bss-viewport-"]'),
      function (v) {
        v.setAttribute('data-anx-was', v.id);
        v.removeAttribute('id');
      }
    );
  }


  function makeNbssRail(slider) {
    var viewport = slider.querySelector('.nbss-viewport');
    var track = slider.querySelector('.nbss-track');

    if (!viewport || !track) return;
    if (viewport.getAttribute('data-anx-rail') === '1') return;

    viewport.setAttribute('data-anx-rail', '1');

    track.style.transform = '';
    track.style.transition = '';
    track.style.width = '';

    var items = Array.prototype.slice.call(track.querySelectorAll('.nbss-item'));
    var loop = makeInfinite(viewport, track, items);

    if (loop) {
      enableMouseDrag(viewport, null);
      loops.push(loop);
    }

    var prevButton = slider.querySelector('.nbss-prev');
    var nextButton = slider.querySelector('.nbss-next');

    function pageDistance() {
      var item = track.querySelector('.nbss-item');
      if (!item) return Math.round(viewport.clientWidth * 0.85);

      var step = item.getBoundingClientRect().width + gapOf(track);
      if (!step) return Math.round(viewport.clientWidth * 0.85);

      var perView = Math.max(1, Math.floor(viewport.clientWidth / step));
      return Math.round(step * perView);
    }

    if (prevButton) prevButton.addEventListener('click', function () {
      viewport.scrollBy({ left: -pageDistance(), behavior: 'smooth' });
    });

    if (nextButton) nextButton.addEventListener('click', function () {
      viewport.scrollBy({ left: pageDistance(), behavior: 'smooth' });
    });

    function syncArrows() {
      var scrollable = viewport.scrollWidth - viewport.clientWidth > 4;
      if (prevButton) prevButton.classList.toggle('nbss-arrow-hidden', !scrollable);
      if (nextButton) nextButton.classList.toggle('nbss-arrow-hidden', !scrollable);
    }

    arrowSyncers.push(syncArrows);
    syncArrows();
  }


  function makeBssRail(viewport) {
    if (viewport.getAttribute('data-anx-rail') === '1') return;

    var template = viewport.querySelector('template');
    if (!template) return;

    viewport.setAttribute('data-anx-rail', '1');

    var rail = document.createElement('div');
    rail.className = 'anx-rail';

    var railTrack = document.createElement('div');
    railTrack.className = 'anx-rail__track';
    railTrack.appendChild(template.content.cloneNode(true));

    rail.appendChild(railTrack);

    viewport.innerHTML = '';
    viewport.appendChild(rail);
    viewport.style.minHeight = '';

    var items = Array.prototype.slice.call(railTrack.querySelectorAll('.bss-item'));
    var loop = makeInfinite(rail, railTrack, items);

    if (loop) {
      enableMouseDrag(rail, null);
      loops.push(loop);
    }
  }


  /* ============================================================
     أكورديون الدرج الجانبي
     ============================================================ */

  function buildSidebarAccordion() {
    var nav = document.querySelector('.mobile-sidebar__nav');

    if (!nav) return;
    if (nav.getAttribute('data-anx-accordion') === '1') return;

    nav.setAttribute('data-anx-accordion', '1');

    var toggles = [];

    Array.prototype.forEach.call(nav.querySelectorAll(':scope > ul > li'), function (item) {

      var submenu = item.querySelector('.mobile-sidebar__submenu');
      var link = item.querySelector(':scope > a');

      if (!submenu || !link) return;

      var title = (link.textContent || '').trim();
      var href = link.getAttribute('href');

      if (href) {
        var parentItem = document.createElement('li');
        var parentLink = document.createElement('a');

        parentLink.setAttribute('href', href);
        parentLink.className = 'anx-sub-parent';
        parentLink.textContent = title;

        parentItem.appendChild(parentLink);
        submenu.insertBefore(parentItem, submenu.firstChild);
      }

      var button = document.createElement('button');

      button.type = 'button';
      button.className = 'anx-accordion-toggle';
      button.setAttribute('aria-expanded', 'false');

      var label = document.createElement('span');
      label.className = 'anx-accordion-label';
      label.textContent = title;

      var chevron = document.createElement('span');
      chevron.className = 'anx-accordion-chevron';
      chevron.setAttribute('aria-hidden', 'true');

      button.appendChild(label);
      button.appendChild(chevron);

      item.replaceChild(button, link);

      submenu.hidden = true;

      toggles.push({ button: button, submenu: submenu });

      button.addEventListener('click', function () {
        var wasOpen = button.getAttribute('aria-expanded') === 'true';

        toggles.forEach(function (entry) {
          entry.button.setAttribute('aria-expanded', 'false');
          entry.submenu.hidden = true;
        });

        if (!wasOpen) {
          button.setAttribute('aria-expanded', 'true');
          submenu.hidden = false;
        }
      });

    });
  }


  /* ============================================================
     ترتيب الهيدر

     .site-header__brand هو <a>، فما نقدر نحط الزر داخله (زر داخل
     رابط = HTML غير صالح). نلفّ الاثنين بحاوية تأخذ محل اللوجو
     في ترتيب الصف.
     ============================================================ */

  function placeSidebarToggle() {
    var toggle = document.querySelector('.sidebar-toggle');
    var brand = document.querySelector('.site-header__brand');

    if (!toggle || !brand || !brand.parentNode) return;
    if (toggle.getAttribute('data-anx-placed') === '1') return;

    toggle.setAttribute('data-anx-placed', '1');

    var group = document.createElement('div');
    group.className = 'anx-brand-group';

    brand.parentNode.insertBefore(group, brand);
    group.appendChild(toggle);
    group.appendChild(brand);
  }


  function placeLocaleSwitcher() {
    var form = document.getElementById('anx-locale-form');
    var actions = document.querySelector('.site-header__actions');

    if (!form || !actions) return;
    if (form.getAttribute('data-anx-placed') === '1') return;

    form.setAttribute('data-anx-placed', '1');

    /* أول عنصر = الطرف الملاصق للبحث، بالاتجاهين.
       في الـ DOM مو بـ order عشان ترتيب Tab يطابق الترتيب المرئي. */
    actions.insertBefore(form, actions.firstChild);

    var host = document.querySelector('[data-anx-locale-host]');
    if (host && host.parentNode) host.parentNode.removeChild(host);
  }


  function bindLocaleSwitcher() {
    var select = document.getElementById('anx-locale-select');

    if (!select || !select.form) return;
    if (select.getAttribute('data-anx-bound') === '1') return;

    select.setAttribute('data-anx-bound', '1');

    select.addEventListener('change', function () { select.form.submit(); });
  }


  /* ============================================================
     صندوق البحث — إضافات

     إضافية بحتة: ما نلمس منطق الجلب ولا عرض النتائج الموجود
     بالقسم (SKU وحالة التوفر). نضيف فوقه: زر مسح، أيقونة بزر
     الإرسال، وتنقل بلوحة المفاتيح داخل النتائج.
     ============================================================ */

  function enhanceSearch() {
    var form = document.getElementById('live-search-form');
    var input = document.getElementById('live-search-input');
    var results = document.getElementById('live-search-results');

    if (!form || !input) return;
    if (form.getAttribute('data-anx-search') === '1') return;

    form.setAttribute('data-anx-search', '1');

    /* --- زر الإرسال: أيقونة + نص --- */

    var submit = form.querySelector('.live-search-form__submit');

    if (submit && !submit.querySelector('.anx-submit-icon')) {
      var labelText = (submit.textContent || '').trim();

      submit.textContent = '';

      submit.insertAdjacentHTML(
        'afterbegin',
        '<svg class="anx-submit-icon" width="16" height="16" viewBox="0 0 24 24"' +
        ' fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"' +
        ' aria-hidden="true"><circle cx="11" cy="11" r="7"/>' +
        '<line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
      );

      var labelSpan = document.createElement('span');
      labelSpan.className = 'anx-submit-text';
      labelSpan.textContent = labelText;
      submit.appendChild(labelSpan);
    }

    /* --- زر المسح --- */

    var clear = document.createElement('button');

    clear.type = 'button';
    clear.className = 'anx-search-clear';
    clear.setAttribute('aria-label', document.documentElement.lang === 'ar' ? 'مسح البحث' : 'Clear search');
    clear.innerHTML = '&times;';

    input.parentNode.insertBefore(clear, input.nextSibling);

    function syncClear() {
      clear.classList.toggle('is-visible', input.value.trim().length > 0);
    }

    input.addEventListener('input', syncClear);
    syncClear();

    clear.addEventListener('click', function () {
      input.value = '';
      syncClear();

      if (results) {
        results.hidden = true;
        results.innerHTML = '';
      }

      input.focus();
    });

    /* --- تنقل بلوحة المفاتيح داخل النتائج --- */

    if (!results) return;

    function syncResultsViewport() {
      if (results.hidden) return;

      var rect = results.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 640;
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;

      if (window.visualViewport) {
        viewportHeight = window.visualViewport.height;
      }

      var gap = isMobile ? 10 : 16;
      var available = Math.floor(viewportHeight - rect.top - gap);
      var minHeight = isMobile ? 160 : 220;
      var maxHeight = isMobile ? Math.min(420, viewportHeight * 0.62) : 500;

      available = Math.max(minHeight, Math.min(maxHeight, available));
      results.style.setProperty('--anx-live-search-max-height', available + 'px');
    }

    input.addEventListener('focus', syncResultsViewport);
    input.addEventListener('input', function () {
      window.setTimeout(syncResultsViewport, 0);
    });

    window.addEventListener('resize', syncResultsViewport, { passive: true });
    window.addEventListener('orientationchange', function () {
      window.setTimeout(syncResultsViewport, 250);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncResultsViewport, { passive: true });
      window.visualViewport.addEventListener('scroll', syncResultsViewport, { passive: true });
    }

    if (window.MutationObserver) {
      new MutationObserver(syncResultsViewport).observe(results, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
    }

    var activeIndex = -1;

    function itemList() {
      return results.querySelectorAll('.live-search-results__item');
    }

    function setActive(index) {
      var list = itemList();
      if (!list.length) return;

      if (index < 0) index = list.length - 1;
      if (index >= list.length) index = 0;

      Array.prototype.forEach.call(list, function (el) {
        el.classList.remove('is-active');
      });

      list[index].classList.add('is-active');
      list[index].scrollIntoView({ block: 'nearest' });

      activeIndex = index;
    }

    input.addEventListener('input', function () { activeIndex = -1; });

    input.addEventListener('keydown', function (e) {
      if (results.hidden) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(activeIndex + 1);
        return;
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(activeIndex - 1);
        return;
      }

      if (e.key === 'Enter') {
        var list = itemList();

        if (activeIndex >= 0 && list[activeIndex]) {
          e.preventDefault();
          window.location.href = list[activeIndex].getAttribute('href');
        }

        return;
      }

      if (e.key === 'Escape') activeIndex = -1;
    });
  }


  /* ============================================================
     قفل سكرول آمن على iOS عند فتح الدرج
     ============================================================ */

  function bindDrawerScrollLock() {
    var sidebar = document.getElementById('mobile-sidebar');

    if (!sidebar || !window.MutationObserver) return;

    var savedY = 0;

    new MutationObserver(function () {
      var isOpen = sidebar.classList.contains('is-active');
      var isLocked = document.body.classList.contains('anx-locked');

      if (isOpen && !isLocked) {
        savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
        document.body.style.top = (-savedY) + 'px';
        document.body.classList.add('anx-locked');
        return;
      }

      if (!isOpen && isLocked) {
        document.body.classList.remove('anx-locked');
        document.body.style.top = '';
        window.scrollTo(0, savedY);
      }
    }).observe(sidebar, { attributes: true, attributeFilter: ['class'] });
  }


  /* ============================================================
     عناصر شريط الهاتف تبقى فعالة حتى لو تأخر سكربت قسم الهيدر
     ============================================================ */

  function bindMobileControls() {
    var sidebar = document.getElementById('mobile-sidebar');
    var backdrop = document.getElementById('sidebar-backdrop');
    var closeButton = sidebar && sidebar.querySelector('.sidebar-close');
    var searchInput = document.getElementById('live-search-input');
    var lastTrigger = null;

    if (!sidebar || sidebar.getAttribute('data-anx-controls-bound') === '1') return;
    sidebar.setAttribute('data-anx-controls-bound', '1');

    function open(trigger) {
      lastTrigger = trigger || document.activeElement;
      sidebar.inert = false;
      sidebar.classList.add('is-active');
      sidebar.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-active');
      document.body.classList.add('sidebar-open');
      document.querySelectorAll('.sidebar-toggle, [data-mobile-menu]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
      window.setTimeout(function () {
        if (closeButton) closeButton.focus({ preventScroll: true });
      }, 40);
    }

    function close() {
      sidebar.classList.remove('is-active');
      sidebar.inert = true;
      sidebar.setAttribute('aria-hidden', 'true');
      sidebar.querySelectorAll('[aria-expanded="true"][aria-controls]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
      if (backdrop) backdrop.classList.remove('is-active');
      document.body.classList.remove('sidebar-open');
      document.querySelectorAll('.sidebar-toggle, [data-mobile-menu]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus({ preventScroll: true });
      }
    }

    document.querySelectorAll('.sidebar-toggle, [data-mobile-menu]').forEach(function (button) {
      if (button.getAttribute('data-anx-menu-bound') === '1') return;
      button.setAttribute('data-anx-menu-bound', '1');
      button.addEventListener('click', function () { open(button); });
      button.addEventListener('touchend', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        open(button);
      }, { passive: false });
    });

    window.addEventListener('pageshow', function () { if (sidebar.classList.contains('is-active')) sidebar.inert = false; });
    window.addEventListener('resize', function () { if (innerWidth > 900 && sidebar.classList.contains('is-active')) close(); }, { passive: true });
    if (closeButton) closeButton.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && sidebar.classList.contains('is-active')) close();
    });

    document.querySelectorAll('[data-mobile-search]').forEach(function (button) {
      if (button.getAttribute('data-anx-search-bound') === '1') return;
      button.setAttribute('data-anx-search-bound', '1');
      button.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
        window.setTimeout(function () {
          if (searchInput) searchInput.focus({ preventScroll: true });
        }, REDUCED ? 0 : 260);
      });
      button.addEventListener('touchend', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
        window.setTimeout(function () {
          if (searchInput) searchInput.focus({ preventScroll: true });
        }, REDUCED ? 0 : 260);
      }, { passive: false });
    });
  }


  /* ============================================================
     تنسيق أسعار الدينار بدون أصفار عشرية
     ============================================================ */

  var PRICE_SELECTORS = [
    '.price-box .new-price',
    '.price-box .old-price',
    '.agc-price-now',
    '.agc-price-was',
    '.nbss-current-price',
    '.nbss-compare-price',
    '.nbss-savings',
    '.apx-price-now',
    '.apx-price-was',
    '.apx-bar-price',
    '.subtotal-price',
    '.total-price',
    '.item-price',
    '.price-sale',
    '.compare-price',
    '.pro-price',
    '.product-price',
    '.bss-price-current',
    '.bss-price-compare',
    '.order-t-price',
    '.giftcard__tooltip-label',
    '.amount',
    '.money',
    '[data-apx-price]',
    '[data-apx-was]',
    '[data-apx-bar-price]'
  ].join(',');

  var moneyFormatterBound = false;

  function withThousands(value) {
    var normalized = String(value || '').replace(/,/g, '');
    if (!/^\d+$/.test(normalized) || normalized.length < 4) return normalized;
    return Number(normalized).toLocaleString('en-US');
  }

  function formatPriceText(text) {
    if (!text || text.indexOf('%') !== -1) return text;

    return text.replace(/(\d{1,3}(?:,\d{3})+|\d+)(?:[.,]0{1,3})?/g, function (match, number) {
      return withThousands(number);
    });
  }

  function formatPriceElement(el) {
    if (!el || !el.textContent) return;

    var current = el.textContent;
    var next = formatPriceText(current);

    if (next !== current) el.textContent = next;
  }

  function formatMoneyNodes(scope) {
    var root = scope || document;
    var nodes = [];

    if (root.nodeType === 1 && root.matches && root.matches(PRICE_SELECTORS)) {
      nodes.push(root);
    }

    if (root.querySelectorAll) {
      nodes = nodes.concat(Array.prototype.slice.call(root.querySelectorAll(PRICE_SELECTORS)));
    }

    nodes.forEach(formatPriceElement);
  }

  function bindMoneyFormatter() {
    formatMoneyNodes(document);

    if (moneyFormatterBound || !window.MutationObserver || !document.body) return;

    moneyFormatterBound = true;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          var parent = mutation.target && mutation.target.parentElement;
          if (parent) formatMoneyNodes(parent);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          formatMoneyNodes(node);
        });

        if (mutation.target) formatMoneyNodes(mutation.target);
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }


  /* ============================================================
     التشغيل
     ============================================================ */

  function apply(scope) {
    var root = scope || document;

    standDownLegacy(root);

    Array.prototype.forEach.call(root.querySelectorAll('.nbss-slider'), makeNbssRail);
    Array.prototype.forEach.call(root.querySelectorAll('.bss-viewport'), makeBssRail);
  }

  apply(document);
  buildSidebarAccordion();
  placeSidebarToggle();
  placeLocaleSwitcher();
  bindLocaleSwitcher();
  enhanceSearch();
  bindMobileControls();
  bindDrawerScrollLock();
  bindMoneyFormatter();


  var lastWidth = window.innerWidth;
  var resizeTimer = null;

  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;

    lastWidth = window.innerWidth;

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      arrowSyncers.forEach(function (sync) { sync(); });
      loops.forEach(function (loop) { loop.normalize(); });
    }, 200);
  }, { passive: true });


  document.addEventListener('shopify:section:load', function (event) {
    var scope = null;

    if (event.detail && event.detail.sectionId) {
      scope = document.getElementById('shopify-section-' + event.detail.sectionId);
    }

    setTimeout(function () {
      apply(scope || document);
      buildSidebarAccordion();
      placeSidebarToggle();
      placeLocaleSwitcher();
      bindLocaleSwitcher();
      enhanceSearch();
      bindMobileControls();
      bindMoneyFormatter();
    }, 0);
  });

})();
